import { KYMW2200Component } from './kymw2200.component';

/**
 * ＯＣＲデータメール送信画面の値を管理するクラス
 *
 * @export KYMW2200Model
 * @class KYMW2200Model
 */
export class KYMW2200Model {

  kymw2200Component: KYMW2200Component;

  /** 受注コード */
  public orderCode = String('');
  /** OCR印刷会社名 */
  public codeValueName = String('');
  /** メールアドレス */
  public mailAddress = String('');

}
